/* Muse Aria -- GM-style cart: slide-in Shopping Bag drawer + "added to bag"
   panel (both from the right). Self-contained. Detects add-to-cart via network
   interception (works with Dawn's form AND third-party/pre-order apps) and the
   cart icon. Keeps a "Ships within 1 business day" reassurance line. */
(function () {
  'use strict';

  var routes = window.routes || {};
  var URL_ADD = (routes.cart_add_url || '/cart/add') + '.js';
  var URL_CHANGE = (routes.cart_change_url || '/cart/change') + '.js';
  var URL_CART = (routes.cart_url || '/cart');
  var SHIP_TEXT = 'Ships within 1 business day';
  var SHIP_PREORDER = 'Ships within 7-10 business days';
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;

  /* nfcube pre-order app adds a hidden line-item property "_is_preorder". */
  function isPreorder(item) {
    return !!(item && item.properties && (item.properties._is_preorder || item.properties['_is_preorder']));
  }
  function shipTextFor(item) { return isPreorder(item) ? SHIP_PREORDER : SHIP_TEXT; }

  function money(cents) {
    var n = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '฿ ' + n;
  }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var ICON_CLOSE = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16"/></svg>';
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/></svg>';

  var overlay, drawer, added, built = false;

  function build() {
    if (built) return;
    built = true;
    overlay = document.createElement('div');
    overlay.className = 'ma-cart-overlay';
    drawer = document.createElement('aside');
    drawer.className = 'ma-cart-panel ma-cart-drawer';
    drawer.setAttribute('aria-label', 'Shopping bag');
    added = document.createElement('aside');
    added.className = 'ma-cart-panel ma-cart-added';
    added.setAttribute('aria-label', 'Item added to bag');
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    document.body.appendChild(added);
    overlay.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  function openPanel(panel) {
    build();
    [drawer, added].forEach(function (p) { if (p !== panel) p.classList.remove('is-open'); });
    overlay.classList.add('is-open');
    document.body.classList.add('ma-cart-lock');
    void panel.offsetWidth; /* force reflow so the slide-in transition runs */
    panel.classList.add('is-open');
  }
  function closeAll() {
    if (!built) return;
    drawer.classList.remove('is-open');
    added.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('ma-cart-lock');
  }

  function getCart() {
    return fetch(URL_CART + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateCount(count) {
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:first-child').forEach(function (el) { el.textContent = count; });
  }

  function imgUrl(u, size) {
    if (!u) return '';
    return esc(u).replace(/(\.[a-z]+)(\?|$)/i, '_' + size + 'x$1$2');
  }

  function itemRow(item, line) {
    var img = imgUrl(item.image, 160);
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="ma-cart-variant">' + esc(item.variant_title) + '</p>' : '';
    return '' +
      '<div class="ma-cart-item" data-line="' + line + '">' +
        '<a class="ma-cart-thumb" href="' + esc(item.url) + '">' + (img ? '<img src="' + img + '" alt="' + esc(item.product_title) + '">' : '') + '</a>' +
        '<div class="ma-cart-info">' +
          '<p class="ma-cart-name">' + esc(item.product_title) + '</p>' +
          variant +
          '<p class="ma-cart-price">' + money(item.final_price) + '</p>' +
          '<div class="ma-cart-qty" data-line="' + line + '">' +
            '<button type="button" data-act="dec" aria-label="Decrease">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-act="inc" aria-label="Increase">+</button>' +
          '</div>' +
          '<p class="ma-cart-ship">' + ICON_TRUCK + '<span>' + shipTextFor(item) + '</span></p>' +
        '</div>' +
        '<div class="ma-cart-item-right">' +
          '<button type="button" class="ma-cart-remove" data-act="remove" data-line="' + line + '">Remove</button>' +
        '</div>' +
      '</div>';
  }

  function renderDrawer(cart) {
    var count = cart.item_count;
    var head = '<div class="ma-cart-head"><p class="ma-cart-title">Shopping Bag<sup>' + count + '</sup></p>' +
      '<button type="button" class="ma-cart-close" aria-label="Close">' + ICON_CLOSE + '</button></div>';
    if (!count) {
      drawer.innerHTML = head +
        '<div class="ma-cart-empty">' +
          '<p>There’s nothing in your Shopping Bag, yet.</p>' +
          '<a class="ma-cart-btn ma-cart-btn--ghost" href="/collections/all">Continue shopping</a>' +
        '</div>';
    } else {
      var rows = cart.items.map(function (it, i) { return itemRow(it, i + 1); }).join('');
      var noteShip = cart.items.some(isPreorder) ? SHIP_PREORDER : SHIP_TEXT;
      drawer.innerHTML = head +
        '<div class="ma-cart-body">' + rows + '</div>' +
        '<div class="ma-cart-foot">' +
          '<div class="ma-cart-rows">' +
            '<div class="ma-cart-row"><span class="mac-muted">Subtotal</span><span>' + money(cart.items_subtotal_price) + '</span></div>' +
            '<div class="ma-cart-row"><span class="mac-muted">Shipping</span><span>Calculated at checkout</span></div>' +
            '<div class="ma-cart-row ma-cart-row--total"><span>Total</span><span>' + money(cart.total_price) + '</span></div>' +
          '</div>' +
          '<p class="ma-cart-note">' + ICON_TRUCK + '<span>' + noteShip + '</span></p>' +
          '<a class="ma-cart-btn ma-cart-btn--primary" href="/checkout">Checkout · ' + money(cart.total_price) + '</a>' +
          '<button type="button" class="ma-cart-btn ma-cart-btn--ghost" data-act="continue">Continue shopping</button>' +
        '</div>';
    }
    bindClose(drawer);
    updateCount(count);
  }

  function renderAdded(cart, item) {
    var count = cart.item_count;
    var img = imgUrl(item.image, 200);
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="ma-cart-variant">' + esc(item.variant_title) + '</p>' : '';
    added.innerHTML =
      '<div class="ma-cart-head"><p class="ma-cart-title">Shopping Bag<sup>' + count + '</sup></p>' +
        '<button type="button" class="ma-cart-close" aria-label="Close">' + ICON_CLOSE + '</button></div>' +
      '<p class="ma-cart-banner">' + esc(item.product_title) + ' has been added to your Shopping Bag.</p>' +
      '<div class="ma-cart-body">' +
        '<div class="ma-cart-item">' +
          '<a class="ma-cart-thumb" href="' + esc(item.url) + '">' + (img ? '<img src="' + img + '" alt="' + esc(item.product_title) + '">' : '') + '</a>' +
          '<div class="ma-cart-info">' +
            '<p class="ma-cart-name">' + esc(item.product_title) + '</p>' + variant +
            '<p class="ma-cart-price">' + money(item.final_price) + '</p>' +
            '<p class="ma-cart-ship">' + ICON_TRUCK + '<span>' + shipTextFor(item) + '</span></p>' +
          '</div>' +
          '<div></div>' +
        '</div>' +
      '</div>' +
      '<div class="ma-cart-foot">' +
        '<div class="ma-cart-actions">' +
          '<button type="button" class="ma-cart-btn ma-cart-btn--ghost" data-act="viewbag">View bag</button>' +
          '<a class="ma-cart-btn ma-cart-btn--primary" href="/checkout">Checkout</a>' +
        '</div>' +
      '</div>';
    bindClose(added);
    added.querySelector('[data-act="viewbag"]').addEventListener('click', openDrawer);
    updateCount(count);
  }

  function bindClose(panel) {
    var b = panel.querySelector('.ma-cart-close');
    if (b) b.addEventListener('click', closeAll);
  }

  function openDrawer(e) {
    if (e && e.preventDefault) e.preventDefault();
    build();
    getCart().then(function (cart) { renderDrawer(cart); openPanel(drawer); });
  }

  function changeLine(line, qty) {
    return fetch(URL_CHANGE, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderDrawer(cart); return cart; });
  }

  var lastAdd = 0;
  function handleAdd(maybeItem) {
    var now = Date.now();
    if (now - lastAdd < 900) return;
    lastAdd = now;
    build();
    getCart().then(function (cart) {
      var items = cart.items || [];
      var item = null;
      var vid = maybeItem && (maybeItem.variant_id || maybeItem.id);
      if (vid) { item = items.filter(function (i) { return i.id === vid || i.variant_id === vid; }).pop(); }
      if (!item) item = (maybeItem && maybeItem.product_title) ? maybeItem : (items.length ? items[items.length - 1] : null);
      if (!item) return;
      renderAdded(cart, item);
      openPanel(added);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-act]') : null;
    if (!btn || !drawer || !drawer.contains(btn)) return;
    var act = btn.getAttribute('data-act');
    if (act === 'continue') { closeAll(); return; }
    var wrap = btn.closest('.ma-cart-item');
    if (!wrap) return;
    var line = parseInt(wrap.getAttribute('data-line'), 10);
    var qtyEl = wrap.querySelector('.ma-cart-qty span');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (act === 'inc') changeLine(line, qty + 1);
    else if (act === 'dec') changeLine(line, Math.max(0, qty - 1));
    else if (act === 'remove') changeLine(line, 0);
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href$="/cart"], #cart-icon-bubble, .header__icon--cart') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (a.id === 'cart-icon-bubble' || a.classList.contains('header__icon--cart') || /\/cart$/.test(href.split('?')[0])) {
      openDrawer(e);
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!form.querySelector('[name="id"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fetch(URL_ADD, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (item) { if (!(item && item.status)) handleAdd(item); })
      .catch(function () {});
  }, true);

  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var isAdd = ADD_RE.test(url);
      var p = _fetch.apply(this, arguments);
      if (isAdd) {
        p.then(function (res) {
          try { res.clone().json().then(function (j) { handleAdd(j); }, function () { handleAdd(null); }); }
          catch (err) { handleAdd(null); }
        }, function () {});
      }
      return p;
    };
  }

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this.__maUrl = url; return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__maUrl && ADD_RE.test(xhr.__maUrl)) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          var j = null;
          try { j = JSON.parse(xhr.responseText); } catch (e) {}
          handleAdd(j);
        }
      });
    }
    return _send.apply(this, arguments);
  };

})();

/* Muse Aria -- mobile sticky add-to-cart bar fixes:
   (1) de-duplicate the product title (the .product__title container also holds a
       reviews-app link with the title text, so grab the <h1> only);
   (2) mirror the real button's label + SOLD OUT / disabled state onto the bar
       button, reading the *visible* submit button (a pre-order app hides the
       original "Add to cart" and shows its own "Pre Order" one). */
(function () {
  'use strict';
  if (location.pathname.indexOf('/products/') === -1) return;

  function titleText() {
    var h1 = document.querySelector('.product__title h1') || document.querySelector('.product__title');
    if (!h1) return '';
    var inner = h1.tagName === 'H1' ? h1 : (h1.querySelector('h1') || h1);
    return (inner.textContent || '').replace(/\s+/g, ' ').trim();
  }

  /* The visible submit button (skip the pre-order-hidden original). */
  function effectiveAtc() {
    var btns = [].slice.call(document.querySelectorAll('.product-form__submit'));
    var vis = btns.filter(function (b) { return b.offsetParent !== null && !b.classList.contains('gPreorderHidden'); });
    return vis[0] || btns.filter(function (b) { return !b.classList.contains('gPreorderHidden'); })[0] || btns[0] || null;
  }

  function syncBar() {
    var bar = document.querySelector('.ma-buybar');
    if (!bar) return false;
    var tEl = bar.querySelector('.ma-buybar-title');
    if (tEl) tEl.textContent = titleText();
    var atc = effectiveAtc();
    var btn = bar.querySelector('.ma-buybar-btn');
    if (atc && btn) {
      var label = (atc.textContent || '').replace(/\s+/g, ' ').trim();
      var soldOut = atc.disabled || /sold out|unavailable/i.test(label);
      if (soldOut) { btn.textContent = /unavailable/i.test(label) ? 'Unavailable' : 'Sold out'; btn.setAttribute('data-soldout', '1'); }
      else { btn.textContent = label || 'Add to cart'; btn.removeAttribute('data-soldout'); }
    }
    return true;
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var tries = 0;
    var iv = setInterval(function () { if (syncBar() || ++tries > 25) clearInterval(iv); }, 150);
    document.addEventListener('change', function () { setTimeout(syncBar, 300); });
  });
})();
